import FeatureTable from '@/common/ui/FeatureTable';
import { ProIcon } from '@/common/ui/UpgradeButton';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@shadcn/components/dialog';

interface ProFeatureModalProps {
  feature: string | null;
  onClose: () => void;
}
export default function ProFeatureModal({
  feature,
  onClose,
}: ProFeatureModalProps) {
  return (
    <Dialog open={!!feature} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <ProIcon size={5} />
            <span>
              {feature}{' '}
              {feature?.charAt(feature.length - 1) === 's' ? 'are' : 'is'}{' '}
              available on a Spellcaster Pro subscription
            </span>
          </DialogTitle>
          <DialogDescription>
            See what else you get on a Spellcaster Pro subscription below
          </DialogDescription>
        </DialogHeader>

        <FeatureTable showRecommended showPricing showCTAs />
      </DialogContent>
    </Dialog>
  );
}
